
<pagination-template [id]= "_name"  #p="paginationApi" (pageChange)=getData($event)>
    
    <div class="pageHeader">
        <div class="firstPageIndex">
            <a *ngIf="!p.isFirstPage()" (click)="p.setCurrent(1)">
               <i class="fa fa-angle-double-left" aria-hidden="true"></i></a>
        </div>
        <div class="pagination-previous">
            <a *ngIf="!p.isFirstPage()" (click)="p.previous()">
                < </a>
        </div>
        <div *ngFor="let page of p.pages" [class.current]="p.getCurrent() === page.value">
            <a (click)="p.setCurrent(page.value)" *ngIf="p.getCurrent() !== page.value">
                                <span>{{ page.label }}</span>
                            </a>
            <div *ngIf="p.getCurrent() === page.value">
                <span>{{ page.label }}</span>
            </div>
        </div>
        <!-- <div class="pagination-next" [class.disabled]="p.isLastPage()">
                            <a (click)="p.next()" [style.cursor]="!p.isLastPage ? 'not-allowed' : 'none'"> >> </a>
                        
                        </div> -->
        <div class="pagination-next" [class.disabled]="p.isLastPage()">
            <a *ngIf="!p.isLastPage()" (click)="p.next()"> > </a>
        </div>
        <div class="lastPageIndex">
            <a *ngIf="!p.isLastPage()" (click)="p.setCurrent(p.getLastPage())"> <i class="fa fa-angle-double-right" aria-hidden="true"></i> </a>
        </div>

    </div>

</pagination-template>